<template>
  <div class="disposition-wrapper xmx-auto pt-2 pb-10">
    <div class="d-flex justify-center pb-3">
      <logo vertical height="65px" />
    </div>
    <v-card max-width="600px" class="mx-auto" tile>
      <div class="gradient" />
      <v-card-text class="px-8">
        <p>Here is the summary of a recent call:</p>

        <section class="mb-8">
          <h3 class="text-decoration-underline">Call Details</h3>
          <div class="field-pair d-flex flex-column">
            <div class="label">Agent</div>
            <div class="value">Taylor Conway</div>
          </div>
          <div class="field-pair d-flex flex-column">
            <div class="label">Call Type</div>
            <div class="value">Incoming call</div>
          </div>
          <div class="field-pair d-flex flex-column">
            <div class="label">Duration</div>
            <div class="value">00:45</div>
          </div>
        </section>

        <section class="mb-8">
          <h3 class="text-decoration-underline">Caller Information</h3>
          <div class="field-pair d-flex flex-column">
            <div class="label">First Name</div>
            <div class="value">Jane</div>
          </div>
          <div class="field-pair d-flex flex-column">
            <div class="label">Last Name</div>
            <div class="value">Doe</div>
          </div>
          <div class="field-pair d-flex flex-column">
            <div class="label">Email</div>
            <div class="value">jane.doe@customer.com</div>
          </div>
          <div class="field-pair d-flex flex-column">
            <div class="label">Phone Number</div>
            <div class="value">123-123-1234</div>
          </div>
        </section>

        <section class="mb-8">
          <h3 class="text-decoration-underline">Notes</h3>
          <p>
            Mrs. Doe called in asking about the updated business hours since she wants to stop in for an adjustment
            tomorrow afternoon.
            <br />
            We confirmed that the chiropractor will be open tomorrow from 9:00am-6:00pm but closed between 12:30-2:00pm.
          </p>
        </section>

        <v-divider class="divider mt-16 mb-4" />
        <p class="caption text-center">
          Thank you for choosing Epic Receptionists.
          <br />
          We take your business seriously and appreciate you making us a member of your team.
          <br />
          Questions or problems? You can respond to this email or give us a call at
          <a href="tel:1-844-923-4321">1-844-923-4321</a>
        </p>
      </v-card-text>
      <v-divider />
      <v-card-actions class="caption">
        <div>Epic Receptionists, LLC</div>
        <v-spacer />
        <div class="d-flex">
          <a
            class="ml-2 d-none d-sm-flex"
            href="http://instagram.com/epic.receptionists"
            target="_blank"
            rel="noopener"
          >
            <span class="d-sr-only">Instagram</span>
            <v-icon small>{{ iconInstagram }}</v-icon>
          </a>
          <a
            class="ml-2 d-none d-sm-flex"
            href="https://www.facebook.com/EpicReceptionists"
            target="_blank"
            rel="noopener"
          >
            <span class="d-sr-only">Facebook</span>
            <v-icon small>{{ iconFb }}</v-icon>
          </a>
          <a
            class="ml-2 d-none d-sm-flex"
            href="https://www.linkedin.com/company/epic-receptionists"
            target="_blank"
            rel="noopener"
          >
            <span class="d-sr-only">LinedIn</span>
            <v-icon small>{{ iconLinkedIn }}</v-icon>
          </a>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import { mdiInstagram, mdiFacebook, mdiLinkedin } from '@mdi/js'
export default {
  components: {
    Logo
  },

  data: () => ({
    iconInstagram: mdiInstagram,
    iconFb: mdiFacebook,
    iconLinkedIn: mdiLinkedin
  })
}
</script>

<style scoped lang="scss">
.disposition-wrapper {
  // width: 600px;
  background-color: #f0f0f0;
}

.gradient {
  height: 8px;
  width: 100%;
  background: #3333ff; /* Old browsers */
  background: -moz-linear-gradient(-45deg, #3333ff 0%, #0cecdc 99%); /* FF3.6-15 */
  background: -webkit-linear-gradient(-45deg, #3333ff 0%, #0cecdc 99%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(135deg, #3333ff 0%, #0cecdc 99%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3333ff', endColorstr='#0cecdc',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}

.field-pair {
  margin-bottom: 5px;

  .label {
    font-size: 10px;
    margin-bottom: -10px;
  }

  .value {
    font-weight: 900;
  }
}

.divider {
  width: 40%;
  margin: auto;
}
</style>
